import { fork, all } from 'redux-saga/effects';
import * as SelectSagas from './index';

export default function* rootSaga() {
  yield all([...Object.values(SelectSagas)].map(fork));
}
